var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBluetoothControlsSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.8994141,6.1005859l-1.4140625,1.4140625C26.7519531,9.78125,28,12.7949219,28,16 s-1.2480469,6.21875-3.5146484,8.4853516l1.4140625,1.4140625C31.3583984,20.4404297,31.3583984,11.5595703,25.8994141,6.1005859z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3642578,9.6357422l-1.4140625,1.4140625c2.7285156,2.7294922,2.7294922,7.1708984,0,9.9003906l1.4140625,1.4140625 C25.8730469,18.8554688,25.8730469,13.1455078,22.3642578,9.6357422z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4140625,14.5859375C17.7919922,14.9638672,18,15.4658203,18,16s-0.2080078,1.0361328-0.5859375,1.4140625 l1.4140625,1.4140625C19.5839844,18.0732422,20,17.0693359,20,16c0-1.0683594-0.4160156-2.0722656-1.171875-2.828125 L17.4140625,14.5859375z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,8c0-0.9121094-0.3554688-1.7695312-1-2.4140625L10.9140625,0.5C10.5917969,0.1777344,10.1630859,0,9.7070312,0 C8.765625,0,8,0.765625,8,1.7070312v11.8789062L2.7070312,8.2929688L1.2929688,9.7070312L7.5859375,16l-6.2929688,6.2929688 l1.4140625,1.4140625L8,18.4140625v11.8789062C8,31.234375,8.765625,32,9.7070312,32 c0.4560547,0,0.8847656-0.1777344,1.2070312-0.5L16,26.4140625C16.6445312,25.7695312,17,24.9121094,17,24 s-0.3554688-1.7695312-1-2.4140625L10.4140625,16L16,10.4140625C16.6445312,9.7695312,17,8.9121094,17,8z M14.5859375,23 C14.8525391,23.2675781,15,23.6220703,15,24s-0.1474609,0.7324219-0.4140625,1L10,29.5859375v-11.171875L14.5859375,23z  M14.5859375,9L10,13.5859375V2.4140625L14.5859375,7C14.8525391,7.2675781,15,7.6220703,15,8S14.8525391,8.7324219,14.5859375,9z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluetoothControlsSmall);
export default __webpack_public_path__ + "static/media/bluetooth-controls--small.02ecd05c3399535d50a351014d6bccd4.svg";
export { ForwardRef as ReactComponent };